import { SafeAreaProvider } from "react-native-safe-area-context";

export default SafeAreaProvider;
